<!--
	Legend panel for the Interventions tab: one collapsible section per intervention type, each
	flagged with a dot while any of its layers has a visible item.
-->
<script lang="ts">
	import LegendSection from '#lib/components/LegendSection.svelte';
	import InterventionsSignsLegend from './InterventionsSignsLegend.svelte';
	import InterventionsSubLegend from './InterventionsSubLegend.svelte';
	import { legendStore } from '#lib/stores/legendStore.svelte.js';
	import { EInterventions } from '../interfaces';

	const E = EInterventions;

	// `systemIds` drive the dot; the Signs section has its own body.
	const sections: { heading: string; title: string; systemIds: EInterventions[] }[] = [
		{
			heading: 'Signs',
			title: 'Signs and Plaques',
			systemIds: [E.CurveAdvisorySigns, E.CurveAdvisorySpeeds]
		},
		{
			heading: 'Markings',
			title: 'No Passing Lines',
			systemIds: [E.PassingSightDistance]
		},
		{
			heading: 'Surfacing',
			title: 'Pavement Friction Focus Areas',
			systemIds: [E.PavementFrictionFocusAreas]
		},
		{
			heading: 'Barriers',
			title: 'Clear Zone',
			systemIds: [E.ClearZone]
		},
		{
			heading: 'Speed',
			title: 'Speed limit review',
			systemIds: [E.SpeedLimitReview]
		},
		{
			heading: 'Visibility',
			title: 'Stopping Sight Distance',
			systemIds: [E.StoppingSightDistance, E.SSDObstructions]
		}
	];

	function isAnyEnabled(systemIds: EInterventions[]): boolean {
		return legendStore.layers.some(
			(l) => systemIds.includes(l.systemId as EInterventions) && l.layerAnyEnabled
		);
	}
</script>

<div class="legendBox">
	{#each sections as { heading, title, systemIds } (heading)}
		<LegendSection {heading} collapsible>
			{#snippet action()}
				{#if isAnyEnabled(systemIds)}
					<span class="notificationDot"><span class="screenReaderOnly">(layers on)</span></span>
				{/if}
			{/snippet}
			<h3 class="subHeading">{title}</h3>
			{#if systemIds[0] === E.CurveAdvisorySigns}
				<InterventionsSignsLegend />
			{:else}
				<InterventionsSubLegend systemId={systemIds[0]} pairedSystemId={systemIds[1]} />
			{/if}
		</LegendSection>
	{/each}
</div>

<style>
	.legendBox {
		gap: var(--space-1);
	}

	.notificationDot {
		flex-shrink: 0;
		box-shadow: var(--shadow-sm);
		border-radius: var(--radius-full);
		background-color: var(--accent);
		width: 14px;
		height: 14px;
	}

	.subHeading {
		margin-block: var(--space-1) var(--space-2);
		font-weight: var(--weight-semibold);
		font-size: var(--font-size-sm);
	}
</style>
